import { render } from "./dialog.vue?vue&type=template&id=818c3a12&lang=pug"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
script.render = render

export default script